<template>
    <div
        class="flex items-center gap-x-2 gap-y-1 empty:hidden"
        :class="singleLine ? 'flex-nowrap overflow-hidden' : 'flex-wrap'"
    >
        <!-- Rows wrap a long chip as before; only a card's single line truncates it. -->
        <div
            v-if="file.shared_with_field_staff"
            class="card text-muval-gray-1 flex items-center gap-1.5 rounded-sm px-2 py-0.5 text-xs"
            :class="{ 'min-w-0': singleLine }"
        >
            <span
                class="bg-brand size-1.5 rounded-full"
                :class="{ 'shrink-0': singleLine }"
            />
            <span :class="{ truncate: singleLine }">Shared with field staff</span>
        </div>
        <div
            v-for="tag in file.tags ?? []"
            :key="tag"
            class="card text-muval-gray-1 flex items-center gap-1.5 rounded-sm px-2 py-0.5 text-xs"
            :class="{ 'min-w-0': singleLine }"
        >
            <span
                :style="{ backgroundColor: getColourFromText(tag) }"
                class="size-1.5 rounded-full"
                :class="{ 'shrink-0': singleLine }"
            />
            <span :class="{ truncate: singleLine }">{{ capitalize(tag) }}</span>
        </div>
        <slot />
    </div>
</template>

<script setup lang="ts">
import { getColourFromText } from '@utilities/colors';

/** A stored file's sharing and tag chips, shared by its list row and its card. */

withDefaults(
    defineProps<{
        file: Record<string, any>;
        /** Keeps the chips to one line, truncating them, where a card has no room to wrap. */
        singleLine?: boolean;
    }>(),
    { singleLine: false },
);

const capitalize = (value: string): string => value.charAt(0).toUpperCase() + value.slice(1);
</script>
